import React from 'react';
import { introData } from '../data/mock';
import { Shield, Heart, Scale } from 'lucide-react';

const Intro = () => {
  return (
    <section className="py-20 md:py-32 bg-[rgb(var(--bg-primary))]">
      <div className="container mx-auto px-6 md:px-12 max-w-5xl">
        <div className="text-center mb-16">
          <h2 className="heading-1 mb-6 text-[rgb(var(--burgundy-primary))]">
            {introData.title}
          </h2>
          <div className="w-20 h-1 bg-[rgb(var(--burgundy-primary))] mx-auto mb-8"></div>
          <p className="body-large text-[rgb(var(--text-primary))] max-w-3xl mx-auto leading-relaxed">
            {introData.description}
          </p>
        </div>

        {/* Trust Pillars */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12 mt-16">
          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-[rgb(var(--bg-secondary))]">
              <Shield className="w-8 h-8 text-[rgb(var(--burgundy-primary))]" />
            </div>
            <h3 className="heading-3 mb-3">Experiencia</h3>
            <p className="body-small text-[rgb(var(--text-secondary))]">
              Más de 11 años resolviendo casos complejos con éxito
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-[rgb(var(--bg-secondary))]">
              <Heart className="w-8 h-8 text-[rgb(var(--burgundy-primary))]" />
            </div>
            <h3 className="heading-3 mb-3">Enfoque Humanista</h3>
            <p className="body-small text-[rgb(var(--text-secondary))]">
              Acompañamiento personal en cada etapa del proceso
            </p>
          </div>

          <div className="text-center">
            <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-[rgb(var(--bg-secondary))]">
              <Scale className="w-8 h-8 text-[rgb(var(--burgundy-primary))]" />
            </div>
            <h3 className="heading-3 mb-3">Compromiso</h3>
            <p className="body-small text-[rgb(var(--text-secondary))]">
              Tu confianza y tranquilidad son nuestra prioridad
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Intro;
